import { render } from "./OcsiOnlyChip.vue?vue&type=template&id=b04d24b6&scoped=true"
import script from "./OcsiOnlyChip.vue?vue&type=script&lang=js"
export * from "./OcsiOnlyChip.vue?vue&type=script&lang=js"

import "./OcsiOnlyChip.vue?vue&type=style&index=0&id=b04d24b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b04d24b6"]])

export default __exports__